import React, { Component } from 'react';
import { connect } from 'react-redux';
import HistoryDisplayPres from './../presentational/HistoryDisplayPres';
//import { historySelector } from './../utilsReselect';

class HistoryDisplayContainer extends Component {
  state = {
    isOpen: false,
  };

  onChange = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handleClickAway = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    return (
      <HistoryDisplayPres
        backUrl={this.props.backUrl}
        historyList={this.props.historyList}
        history={this.props.history}
        onChange={this.onChange}
        isOpen={this.state.isOpen}
        type={this.props.type}
        trackClickAnalytics={this.props.trackClickAnalytics}
      />
    );
  }
}

const processHistory = historyList => {
  if (historyList.length) {
    let newList = historyList.filter((item, pos) => historyList[pos - 1] !== item && item);
    return newList.reverse().slice(0, 5);
  }
  return [];
};

const mapStateToProps = state => ({
  historyList: processHistory(state.utils.history),
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HistoryDisplayContainer);
